<div class="popup-overlay">
  <div class="modal-content popup">
    <span class="close-button" (click)="submitDateTime(false)">×</span>

    <div class="content">
      <!-- Client Specific Toggle -->
      <div class="row">
        <label>Client Specific:</label>

        <label class="switch">
          <input type="checkbox" [(ngModel)]="isClientSpecific" />
          <span class="slider round"></span>
        </label>
      </div>

      <br />

      <!-- Client Name -->
      <div class="row" *ngIf="isClientSpecific">
        <div class="col-md-3">
          <label for="client">Client:</label>
        </div>

        <div class="col-md-8">
          <select
            id="client"
            [(ngModel)]="clientName"
            class="form-control"
          >
            <option *ngFor="let client of clientOptions" [value]="client.client_name">
              {{ client.client_name }}
            </option>
          </select>
        </div>
      </div>

      <br />

      <!-- Vessel & IMO only when toggle OFF -->
      <ng-container *ngIf="!isClientSpecific">
  <div class="row">
  <div class="col-md-3">
    <label>Vessel:</label>
  </div>

  <div class="col-md-8 position-relative">

    <input
      type="text"
      class="form-control"
      [(ngModel)]="vesselName"
      (input)="onVesselNameChange(vesselName)"
    />

    <div
      *ngIf="shipNameSuggestions.length"
      class="suggestion-box"
    >
      <div
        class="suggestion-item"
        *ngFor="let vessel of shipNameSuggestions"
        (click)="selectVessel(vessel)"
      >
        {{ vessel.vessel_name }}
      </div>
    </div>

  </div>
</div>

        <br />

<div class="row">
  <div class="col-md-3">
    <label>IMO:</label>
  </div>

  <div class="col-md-8 position-relative">

    <input
      type="text"
      class="form-control"
      [(ngModel)]="imo"
      (input)="onImoChange(imo)"
    />

    <div
      *ngIf="imoSuggestions.length"
      class="suggestion-box"
    >
      <div
        class="suggestion-item"
        *ngFor="let vessel of imoSuggestions"
        (click)="selectImo(vessel)"
      >
        {{ vessel.imo }}
      </div>
    </div>

  </div>
</div>

        <br />
      </ng-container>

      <!-- Status -->
      <div class="row" >
        <div class="col-md-3">
          <label for="status">Status:</label>
        </div>

        <div class="col-md-8">
          <select
            id="status"
            [(ngModel)]="selectedStatus"
            class="form-control"
            (change)="onStatusChange()"
          >
            <option *ngFor="let status of statusOptions" [value]="status">
              {{ status }}
            </option>
          </select>
        </div>
      </div>

      <br />

     <div class="row">
  <div class="col-md-3">
    <label for="reason">Reason:</label>
  </div>

  <div class="col-md-8">
    <select
      id="reason"
      [(ngModel)]="selectedReason"
      class="form-control"
    >
      <option *ngFor="let reason of reasonOptions" [value]="reason">
        {{ reason }}
      </option>
    </select>

    <!-- Show only when Others is selected -->
    <input
      *ngIf="selectedReason === 'Others'"
      type="text"
      class="form-control mt-2"
      placeholder="Enter reason"
      [(ngModel)]="otherReason"
    />
  </div>
</div>


  </div>
      <div class="btn row">
      <button class="hover-clear" (click)="submitDateTime(true)">Submit</button>

      <button class="hover-clear" (click)="submitDateTime(false)">
        Cancel
      </button>
    </div>
</div>
